export const MIN_EXTENSION_LENGTH = 3;
export const MAX_EXTENSION_LENGTH = 4;

// NANP numbers to country code + 10 digits; everything else untouched.
export function normalizeNumber(number) {
  const value = String(number ?? '');
  if (/[^0-9]/.test(value)) return value;
  if (value.length === 10) return `1${value}`;
  return value;
}

export function processNumber(number) {
  if (typeof number === 'number') {
    return number.toString();
  }
  if (typeof number === 'string') {
    return number.replace(/\D/g, '');
  }
};

export function isValidPhoneNumber(number) {
  return /^\d{10,11}$/.test(number);
}

export function isValidExtension(number) {
  return number.length >= MIN_EXTENSION_LENGTH && number.length <= MAX_EXTENSION_LENGTH;
}

export const formatPhone = (phone) => {
  let num;
  if (phone.includes('@')) {
    num = phone.split('@')[0];
  } else {
    num = phone;
  }

  num = num.toString().replace(/[^0-9]/g, '');

  if (num.length === 10) {
    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
  } else if (num.length === 11) {
    return `(${num.slice(1, 4)}) ${num.slice(4, 7)}-${num.slice(7)}`;
  } else {
    return num;
  }
};

export const getNumber = (remote) => {
  if (typeof remote === 'number') {
    return remote.toString();
  }
  return remote.split('@')[0];
};

export const sipUriToNumber = (sipUri) => {
  const match = sipUri.match(/sip:(\d+)/);
  return match ? match[1] : sipUri;
};

// A CRM only holds external contacts — wider than isValidPhoneNumber, which
// rejects international numbers.
export function isExternalNumber(number) {
  const value = String(number ?? '');
  if (/adhoc/i.test(value)) return false;
  if (/[*#]/.test(value)) return false;
  return value.replace(/\D/g, '').length >= 7;
}
